import { EmpregoNaPistaError } from './emprego-na-pista-error';

export class BadInputError extends EmpregoNaPistaError { }



// WEBPACK FOOTER //
// ./src/app/components/shared/errors/bad-input-error.ts